import { currencySymbol } from "../../assets/CurrencySymbols";

export function GetCurrentSymbol(value) {
    if (!value) return "";
    const strVal = String(value).toLowerCase();
    const symbol = currencySymbol.find(
        (item) => item?.name?.toLowerCase() === strVal || item?.label?.toLowerCase() === strVal
    );
    return symbol ? symbol.value : value;
}



export function CalPercentage(fullList=[],current={},name){
    console.log("full list",fullList);
    let list = fullList.filter(i=>i?.productName==name);
    let LowValue = list.find(i=>i.isLow==true)
    console.log("list of item",Number(LowValue?.LCSP),Number(current?.LCSP));
  
    return `(+ ${getPercentageIncrease(Number(LowValue?.LCSP),Number(current?.LCSP))} %)`
  }

  function getPercentageIncrease(oldValue, newValue) {
    if (oldValue === 0) return newValue > 0 ? 0 : 0; // Avoid division by zero
    return (((newValue - oldValue) / oldValue) * 100).toFixed(2);
  }




  export function CalPercentageSelling(fullList=[],current={},name){
    console.log("full list",fullList);
    let list = fullList.filter(i=>i?.productName==name);
    let LowValue = list.find(i=>i.isLow==true)
    console.log("list of item",Number(LowValue?.sellingPrice),Number(current?.sellingPrice));
  
    return `(+ ${getPercentageIncrease(Number(LowValue?.sellingPrice),Number(current?.sellingPrice))} %)`
  }

